import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
    container: {
        width: "100%",
        minWidth: 0
    }
 });